// extracted by mini-css-extract-plugin
export default {"navItemsContainer":"Navbar_navItemsContainer__qsfcX"};